import styled from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const ScFAQSection = styled.div`
  & > h2 {
    ${typography['headline2']};
    color: ${({ theme }) => theme.whiteColor};
    margin-bottom: 24px;

    @media (${device.mobile}) {
      font-size: 20px;
    }
  }
`;

export const ScFAQContainer = styled.div`
  & .title {
    ${typography['profileTitle']};
    margin-bottom: 24px;
    text-align: center;
  }
`;
